'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowBack = function TiArrowBack(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 15.1v-4.3c0-0.4-0.2-0.8-0.5-1.1-0.3-0.4-0.7-0.5-1.2-0.5s-0.8 0.1-1.1 0.5l-10.5 10.3 10.5 10.3c0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5 0.5-0.7 0.5-1.1v-4.2c4.6 0.1 9.6 1 13.3 6.7v-1.7c0-7.7-5.8-14.1-13.3-14.9z' })
        )
    );
};

exports.default = TiArrowBack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-back.js
// module id = 3721
// module chunks = 0